import { render, staticRenderFns } from "./DownTimer.vue?vue&type=template&id=2638811d&scoped=true&"
import script from "./DownTimer.vue?vue&type=script&lang=js&"
export * from "./DownTimer.vue?vue&type=script&lang=js&"
import style0 from "./DownTimer.vue?vue&type=style&index=0&id=2638811d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638811d",
  null
  
)

export default component.exports